/* eslint-disable */
import { getTopicHotList } from '@/api/api'
export const CommunicationActions = {
  updateTag({ commit }, tag) {
    commit('UPDATE_TAG', tag)
  }
}
export const RereshActions = {
  updateDownRefresh({ commit }, refresh) {
    commit('UPDATE_DOWN_REFRESH', refresh)
  }
}
export const MessageActions = {
  updateCount({ commit }, count) {
    commit('UPDATE_COUNT', count)
  },
  updateStarCircleCount({ commit }, count) {
    commit('UPDATE_STAR_CIRCLE_COUNT', count)
  },
  updateTaleCount({ commit }, count) {
    commit('UPDATE_TALE_COUNT', count)
  }
}
export const UserActions = {
  updateUser({ commit }, user) {
    commit('UPDATE_USER', user)
  },
  updateUserAvater({ commit }, avatar) {
    commit('UPDATE_AVATER_USER', avatar)
  },
  updateUserSignName({ commit }, signName) {
    commit('UPDATE_SIGN_USER', signName)
  },
  updateUserNickName({ commit }, nickName) {
    commit('UPDATE_NICKNAME_USER', nickName)
  },
  updateUserGender({ commit }, gender) {
    commit('UPDATE_GENDER', gender)
  },
}
export const TabBarActions = {
  updateTabIndex({ commit }, index) {
    commit('UPDATE_TABBAR_INFDEX', index)
  }
}
export const DynamicTabBarActions = {
  updateDynamicTabIndex({ commit }, index) {
    commit('DYNAMIC_UPDATE_TABBAR_INFDEX', index)
  }
}
export const RouterActions = {
  updateRouter({ commit }, router) {
    commit('UPDATE_ROUTER', router)
  }
}
export const TarBarModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const CenterModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const HomeModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const DynamicModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const MakeComplainsModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const RefiningModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const CalendarModuleAuthActions = {
  updateAuth({ commit }, auth) {
    commit('UPDATE_AUTH', auth)
  }
}
export const TopicHotListModuleAuthActions = {
  async getTopicList({ commit }, id) {
    const result = await getTopicHotList(id)
    if (result.code === 200) {
      commit('UPDATE_HOT_TOPICS', result.detail)
    } else {
      console.log(2222)
    }
  }
}
export const BrowseCoordActions = {
  updataBrowseCoordFindScroll({ commit }, data) {
    commit('UPDATE_BROWSE_COORD_FIND_SCROLL', data)
  },
  setFindListCount({ commit }, data) {
    commit('UPDATE_FIND_LIST_COUNT', data)
  },
  setDynamicScroll({ commit }, data) {
    commit('UPDATE_DYNAMIC_SCROLL', data)
  }
}
